import React from 'react';
import { useNavigate } from 'react-router-dom';

interface MenuItem {
  title: string;
  path: string;
  description: string;
  icon?: string;
}

const Admin: React.FC = () => {
  const navigate = useNavigate();

  const menuItems: MenuItem[] = [
    {
      title: 'Aprovação de Músicas',
      path: '/aprovacao-musicas',
      description: 'Gerencie as músicas pendentes de aprovação',
      icon: '🎵'
    },
    {
      title: 'Denúncias',
      path: '/denuncias',
      description: 'Visualize e gerencie as denúncias do site',
      icon: '⚠️'
    },
    {
      title: 'Mensagens de Ajuda',
      path: '/mensagens-ajuda',
      description: 'Visualize e responda mensagens de ajuda dos usuários',
      icon: '💬'
    },
    {
      title: 'Atualização de Perfis',
      path: '/atualizacao-perfis',
      description: 'Acompanhe as atualizações de perfis de bandas e usuários',
      icon: '👥'
    },
    {
      title: 'Estatísticas',
      path: '/estatisticas',
      description: 'Visualize estatísticas e métricas do site',
      icon: '📊'
    },
    {
      title: 'Configurações',
      path: '/configuracoes',
      description: 'Gerencie as configurações do sistema',
      icon: '⚙️'
    },
    {
      title: 'Validações Pendentes',
      path: '/validacoes-pendentes',
      description: 'Visualize usuários e bandas com validação de celular pendente',
      icon: '📱'
    },
    {
      title: 'Push Geral',
      path: '/push-geral',
      description: 'Envie notificações push para todos os usuários da plataforma',
      icon: '📢'
    }
  ];

  return (
    <div style={styles.container}>
      <h1 style={styles.title}>Painel Administrativo Tribhus</h1>
      <div style={styles.menuGrid}>
        {menuItems.map((item, index) => (
          <div
            key={index}
            style={styles.menuCard}
            onClick={() => navigate(item.path)}
          >
            <div style={styles.cardContent}>
              <span style={styles.icon}>{item.icon}</span>
              <h2 style={styles.cardTitle}>{item.title}</h2>
              <p style={styles.cardDescription}>{item.description}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

const styles = {
  container: {
    padding: '20px',
    maxWidth: '1200px',
    margin: '0 auto',
    backgroundColor: '#f9f9f9',
    borderRadius: '8px',
    boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
  },
  title: {
    fontSize: '28px',
    color: '#333',
    textAlign: 'center' as 'center',
    marginBottom: '40px',
    fontWeight: 'bold',
  },
  menuGrid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))',
    gap: '20px',
    padding: '20px',
  },
  menuCard: {
    backgroundColor: 'white',
    borderRadius: '8px',
    boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
    padding: '20px',
    cursor: 'pointer',
    transition: 'transform 0.2s ease, box-shadow 0.2s ease',
    ':hover': {
      transform: 'translateY(-5px)',
      boxShadow: '0 4px 8px rgba(0, 0, 0, 0.2)',
    },
  },
  cardContent: {
    display: 'flex',
    flexDirection: 'column' as 'column',
    alignItems: 'center',
    textAlign: 'center' as 'center',
  },
  icon: {
    fontSize: '32px',
    marginBottom: '15px',
  },
  cardTitle: {
    fontSize: '20px',
    color: '#333',
    marginBottom: '10px',
    fontWeight: 'bold',
  },
  cardDescription: {
    fontSize: '14px',
    color: '#666',
    margin: 0,
  },
};

export default Admin;